import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import AuthPage from "@/pages/auth/page";
import PendingPage from "@/pages/pending/page";
import MyPage from "@/pages/my/page";
import AdminPage from "@/pages/admin/page";
import EditorPage from "@/pages/editor/page";
import InvitePage from "@/pages/invite/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <AuthPage />,
  },
  {
    path: "/signup",
    element: <AuthPage />,
  },
  {
    path: "/pending",
    element: <PendingPage />,
  },
  {
    path: "/my",
    element: <MyPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/editor",
    element: <EditorPage />,
  },
  {
    path: "/invite/:slug",
    element: <InvitePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;